import tim from '../../tim'
const user = {
    state: {
        currentUserProfile: {},
        currentSiteUser: {},
        isLogin: false,
        isSDKReady: false, // TIM SDK 是否 ready
        userID: 0,
        userSig: '',
        sdkAppID: 0
    },
    mutations: {
        updateCurrentUserProfile(state, userProfile) {
            state.currentUserProfile = userProfile
        },
        updateCurrentSiteUser(state, user) {
            state.currentSiteUser = user;
        },
        toggleIsLogin(state, isLogin) {
            state.isLogin = typeof isLogin === 'undefined' ? !state.isLogin : isLogin
        },
        toggleIsSDKReady(state, isSDKReady) {
            state.isSDKReady = typeof isSDKReady === 'undefined' ? !state.isSDKReady : isSDKReady
        },
        reset(state) {
            Object.assign(state, {
                currentUserProfile: {},
                currentSiteUser: {},
                isLogin: false,
                isSDKReady: false // TIM SDK 是否 ready
            })
        },
        GET_USER_INFO(state, payload) {
            state.userID = payload.userID
            state.userSig = payload.userSig
            state.sdkAppID = payload.sdkAppID
        },
    },
    actions: {
        syncUserProfile(context, user) {
            const imUser = context.state.currentUserProfile;
            let shouldUpdate = {};

            if (imUser.nick != user.nick) {
                shouldUpdate.nick = user.nick;
            }

            if (user.avatar && imUser.avatar != user.avatar) {
                shouldUpdate.avatar = user.avatar;
            }

            if (!_.isEmpty(shouldUpdate)) {
                tim.updateMyProfile(shouldUpdate).then(({ data }) => {
                    context.commit("updateCurrentUserProfile", data);
                });
            }
        },

        // login(context, userID) {
        //   tim
        //     .login({
        //       userID,
        //       userSig: window.genTestUserSig(userID).userSig
        //     })
        //     .then(() => {
        //       context.commit('toggleIsLogin', true)
        //       context.commit('startComputeCurrent')
        //       window.$message({ type: 'success', message: '登录成功' })
        //     })
        //     .catch(imError => {
        //       if (imError.code === 2000) {
        //         window.$message.error(imError.message + ', 请检查是否正确填写了 SDKAPPID')
        //       } else {
        //         window.$message.error(imError.message)
        //       }
        //     })
        // },
        logout(context) {
            // 若有当前会话，在退出登录时已读上报
            if (context.rootState.conversation.currentConversation.conversationID) {
                tim.setMessageRead({ conversationID: context.rootState.conversation.currentConversation.conversationID })
            }
            tim.logout().then(() => {
                context.commit('toggleIsLogin')
                context.commit('stopComputeCurrent')
                context.commit('reset')
            })
        }
    }
}

export default user
